module.exports = __webpack_public_path__ + "static/media/29EUNOG7.1d90bff2.jpg";